/**
 * Aba Checklist em edição (PR4). Vincula/desvincula uma checklist via select
 * (GET /v1/checklist-templates · gate `checklists-basic`). Os itens da checklist
 * vinculada seguem em LEITURA (a edição de itens é do módulo de checklists, não
 * do playbook). Comportamento de não-cumprimento do mockup não tem fonte no
 * Playbook → fora.
 */

import { ChecklistPriorityBadge } from '../PlaybookBadges';
import { useChecklistTemplate, useChecklistTemplateList } from '../use-playbooks';

import type { ChecklistTemplateItemDto } from '../types';
import type { PlaybookForm } from '../use-playbook-form';

export function TabChecklistEdit({ form }: { form: PlaybookForm }): JSX.Element {
  const { draft, set } = form;
  const selectedId = draft.checklistTemplateId;
  const { data: templates, canRead } = useChecklistTemplateList(true);
  const { data: linked } = useChecklistTemplate(selectedId);

  return (
    <div className="pb-panel" role="tabpanel" aria-label="Checklist">
      <h2 className="pb-panel__title">Checklist</h2>

      {!canRead ? (
        <p className="pb-read-value pb-read-value--muted">
          Checklists não estão habilitadas no seu pacote atual — fale com o administrador do tenant.
        </p>
      ) : (
        <div className="pb-field">
          <label className="pb-field__label" htmlFor="pb-checklist">
            Checklist vinculada
          </label>
          <select
            id="pb-checklist"
            className="pb-select"
            value={selectedId ?? ''}
            onChange={(e) => {
              set('checklistTemplateId', e.target.value === '' ? null : e.target.value);
            }}
          >
            <option value="">Nenhuma checklist vinculada</option>
            {templates.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name} (v{t.version})
              </option>
            ))}
          </select>
        </div>
      )}

      {linked !== undefined && (
        <div className="pb-panel__section">
          <span className="pb-panel__section-label">Itens da checklist (leitura)</span>
          {linked.items.length > 0 ? (
            <div className="pb-ci-list">
              {[...linked.items]
                .sort((a, b) => a.order - b.order)
                .map((item: ChecklistTemplateItemDto, i) => (
                  <div key={item.templateItemId} className="pb-ci-row">
                    <span className="pb-ci-row__num">#{i + 1}</span>
                    <div className="pb-ci-row__body">
                      <span className="pb-ci-row__label">{item.name}</span>
                      {item.description !== undefined && item.description !== '' && (
                        <span className="pb-read-value pb-read-value--muted">
                          {item.description}
                        </span>
                      )}
                    </div>
                    <ChecklistPriorityBadge isCritical={item.isCritical} />
                  </div>
                ))}
            </div>
          ) : (
            <p className="pb-read-value pb-read-value--muted">Esta checklist não tem itens.</p>
          )}
        </div>
      )}
    </div>
  );
}
